import React, { useEffect } from "react";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  clickMenuBtn,
  selectIsMenuBtnClicked,
  clickSearchBtn,
  selectIsSearchBtnClicked,
} from "./NavBarSlice.js";

import "./NavBar.css";

export const NavBar = () => {
  const [svgColor, setSvgColor] = useState("#252525");
  const isMenuBtnClicked = useSelector(selectIsMenuBtnClicked);
  const isSearchBtnClicked = useSelector(selectIsSearchBtnClicked);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClickMenuBtn = () => {
    dispatch(clickMenuBtn());
  };

  useEffect(() => {
    if (isMenuBtnClicked) {
      setSvgColor("#fff");
    } else {
      setSvgColor("#252525");
    }
    if (isSearchBtnClicked) {
      dispatch(clickSearchBtn());
    }
  }, [isMenuBtnClicked]);

  const onClickSearchBtn = () => {
    navigate('/search');
  };

  //Style Below

  const styleHeaderContainer = {
    position: "fixed",
    width: "calc(100vw - 2/15*100vw)",
    height: "60px",
    left: "calc(100vw*2/30)",
    top: "40px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: "999",
  };

  const styleLogoNav = {
    textDecoration: "none",
    color: "black",
  };

  const styleHeaderLogo = {
    display: "flex",
    gap: "5px",
    justifyContent: "space-between",
    alignItems: "flex-end",
  };

  const styleHeaderNav = {
    display: "flex",
    flexDirection: "row",
    width: "calc(5/27 * 100%)",
    justifyContent: "space-between",
    alignItems: "center",
  };

  return (
    <div className="navBar_wrapper">
      <NavLink className={"navBar_logo_wrapper"} to={"/"}>
        <div className="navBar_logo">
          <a className="navBar_logo_icon">
            <i className="fa-brands fa-kaggle"></i>
          </a>
          <a className="navBar_logo_title">
            <span>A summertime</span>
            <br />
            <span>project</span>
          </a>
        </div>
      </NavLink>

      <div className="navBar_option_wrapper">
        <a className="navBar_option_item btn-search" onClick={onClickSearchBtn}>
          <span style={{ display: "none" }}>Search</span>
          <svg className="svg-icon" viewBox="0 0 20 20">
            <path
              fill={svgColor}
              d="M12.323,2.398c-0.741-0.312-1.523-0.472-2.319-0.472c-2.394,0-4.544,1.423-5.476,3.625C3.907,7.013,3.896,8.629,4.49,10.102c0.528,1.304,1.494,2.333,2.72,2.99L5.467,17.33c-0.113,0.273,0.018,0.59,0.292,0.703c0.068,0.027,0.137,0.041,0.206,0.041c0.211,0,0.412-0.127,0.498-0.334l1.74-4.23c0.583,0.186,1.18,0.309,1.795,0.309c2.394,0,4.544-1.424,5.478-3.629C16.755,7.173,15.342,3.68,12.323,2.398z M14.488,9.77c-0.769,1.807-2.529,2.975-4.49,2.975c-0.651,0-1.291-0.131-1.897-0.387c-0.002-0.004-0.002-0.004-0.002-0.004c-0.003,0-0.003,0-0.003,0s0,0,0,0c-1.195-0.508-2.121-1.452-2.607-2.656c-0.489-1.205-0.477-2.53,0.03-3.727c0.764-1.805,2.525-2.969,4.487-2.969c0.651,0,1.292,0.129,1.898,0.386C14.374,4.438,15.533,7.3,14.488,9.77z"
            ></path>
          </svg>
        </a>
        <a className="navBar_option_item btn-account">
          <span style={{ display: "none" }}>Account</span>
          <svg className="svg-icon" viewBox="0 0 20 20">
            <path
              fill={svgColor}
              d="M10,10.9c2.373,0,4.303-1.932,4.303-4.306c0-2.372-1.93-4.302-4.303-4.302S5.696,4.223,5.696,6.594C5.696,8.969,7.627,10.9,10,10.9z M10,3.331c1.801,0,3.266,1.463,3.266,3.263c0,1.802-1.465,3.267-3.266,3.267c-1.8,0-3.265-1.465-3.265-3.267C6.735,4.794,8.2,3.331,10,3.331z"
            ></path>
            <path
              fill={svgColor}
              d="M10,12.503c-4.418,0-7.878,2.058-7.878,4.685c0,0.288,0.231,0.52,0.52,0.52c0.287,0,0.519-0.231,0.519-0.52c0-1.976,3.132-3.646,6.84-3.646c3.707,0,6.838,1.671,6.838,3.646c0,0.288,0.234,0.52,0.521,0.52s0.52-0.231,0.52-0.52C17.879,14.561,14.418,12.503,10,12.503z"
            ></path>
          </svg>
        </a>
        <a className="navBar_option_item btn-menu" onClick={onClickMenuBtn}>
          <span style={{ display: "none" }}>Menu</span>
          {!isMenuBtnClicked ? (
            <svg className="svg-icon" viewBox="0 0 20 20">
              <path
                fill={svgColor}
                d="M3.314,4.8h13.372c0.41,0,0.743-0.333,0.743-0.743c0-0.41-0.333-0.743-0.743-0.743H3.314
								c-0.41,0-0.743,0.333-0.743,0.743C2.571,4.467,2.904,4.8,3.314,4.8z M16.686,15.2H3.314c-0.41,0-0.743,0.333-0.743,0.743
								s0.333,0.743,0.743,0.743h13.372c0.41,0,0.743-0.333,0.743-0.743S17.096,15.2,16.686,15.2z M16.686,9.257H3.314
								c-0.41,0-0.743,0.333-0.743,0.743s0.333,0.743,0.743,0.743h13.372c0.41,0,0.743-0.333,0.743-0.743S17.096,9.257,16.686,9.257z"
              ></path>
            </svg>
          ) : (
            <svg className="svg-icon" viewBox="0 0 20 20">
              <path
                fill={svgColor}
                d="M15.898,4.045c-0.271-0.272-0.713-0.272-0.986,0l-4.71,4.711L5.493,4.045c-0.272-0.272-0.714-0.272-0.986,0s-0.272,0.714,0,0.986l4.709,4.711l-4.71,4.711c-0.272,0.271-0.272,0.713,0,0.986c0.136,0.136,0.314,0.203,0.492,0.203c0.179,0,0.357-0.067,0.493-0.203l4.711-4.711l4.71,4.711c0.137,0.136,0.314,0.203,0.494,0.203c0.178,0,0.355-0.067,0.492-0.203c0.273-0.273,0.273-0.715,0-0.986l-4.711-4.711l4.711-4.711C16.172,4.759,16.172,4.317,15.898,4.045z"
              ></path>
            </svg>
          )}
        </a>
      </div>
    </div>
  );
};
